import { marked } from 'marked'

export const unqId = (text: string): string => {
  /** Returns a random string that is reasonably unique (including timestamp) for generating unique element id names */
  var result = ''
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  var charactersLength = characters.length
  for (var i = 0; i < 20; i++) {
    // 20 = length
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return `${text}_${result}_${Date.now()}`
}

export const isMarkdown = (text: string): boolean => {
  // Check for common Markdown patterns
  const markdownPatterns = [
    /^\s*#/, // Header
    /^\s*\*/, // List item
    /^\s*\d+\./, // Ordered list item
    /^\s*\[.*\]:/, // Reference link
    /^\s*!?\[.*\]:/, // Image reference link
    /^\s*\*/, // Emphasis
    /\[.*\]\(.+\)/, // Inline link
    /\!\[.*\]\(.+\)/, // Inline image
    /(?:\r?\n|^)>/, // Blockquote
    /(?:\r?\n|^)\d+\./, // Task list item
  ]

  return markdownPatterns.some(pattern => pattern.test(text))
}
//@ts-ignore
export const markdownToHtml = (markdown: string): string => marked(markdown)
